import React from 'react';

const localStore = (getStorage) => {
  let inMemoryStorage = {};

  const setInMemoryStorage = (key, value) => {
    inMemoryStorage[key] = value;
  };
  const getInMemoryStorage = () => {
    return inMemoryStorage;
  };
  function isSupported() {
    try {
      const testKey = '__some_random_key_you_are_not_going_to_use__';
      getStorage().setItem(testKey, testKey);
      getStorage().removeItem(testKey);
      return true;
    } catch (e) {
      return false;
    }
  }
  function getItem(name) {
    if (isSupported()) {
      return getStorage().getItem(name);
    }
    if (inMemoryStorage.hasOwnProperty(name)) {
      return inMemoryStorage[name];
    }
    return null;
  }
  function removeItem(name) {
    if (isSupported()) {
      getStorage().removeItem(name);
    } else {
      delete inMemoryStorage[name];
    }
  }

  function setItem(name, value) {
    if (isSupported()) {
      getStorage().setItem(name, value);
    } else {
      inMemoryStorage[name] = String(value); // not everyone uses TypeScript
    }
  }
  function clear() {
    if (isSupported()) {
      getStorage().clear();
    } else {
      inMemoryStorage = {};
    }
  }
  return {
    getItem,
    setItem,
    removeItem,
    clear,
  };
};
function setInMemoryStorage(key, value) {
  var setMemory = localStore();
  return setMemory.setInMemoryStorage(key, value);
}
function getInMemoryStorage() {
  var foo = localStore();
  return foo.getInMemoryStorage();
}
export { setInMemoryStorage, getInMemoryStorage };
export default localStore;
